module.exports = __webpack_public_path__ + "img/uk.9f5e849b.png";